<template>
    <div>
        <modal 
        name="requestAuthSignModal" 
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="500px"
        height="auto">
        <div class="v-modal">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">Assign Authorized Signatory</h2>
                <span @click="$modal.hide('requestAuthSignModal');hideAuthSignRequestModal()">
                <em class="material-icons">close</em>
                </span>
            </div>
            <form @submit.prevent data-vv-scope="requestAuthSign" @click="requestErr= ''" >
                <div class="form-container" @click="requestErr=''">
                    <div class="form_group">
                        <div class="con-select w-full select-large">
                            <label class="form_label">Select Signatory<em>*</em></label>
                          <multiselect v-model="selectedAuthSignatory" :options="authSignatoryList"
                            :multiple="false" :hideSelected="false" :close-on-select="true" :clear-on-select="false"
                            :preserve-search="true" :select-label="'Search Signatory'"
                            :placeholder="'Select Signatory'" label="name" track-by="email" :preselect-first="false"
                            :data-vv-as="''" v-validate="'required'" :searchable="true"
                            @search-change="getAuthSignatoryList" name="Signatory" 
                            :tag-placeholder="'Add New Signatory'" :taggable="false" 
                            :key="'Signatory1-Signatory'">
                            <template slot="selection" slot-scope="{ values, isOpen }">
                              <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                                options selected</span>
                              <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                            </template>
                          </multiselect>
                        </div>
                        <span class="text-danger text-sm" v-show="errors.has('requestAuthSign.Signatory')">{{
                          errors.first("requestAuthSign.Signatory") }}</span>
                    </div>
                    <template v-if="selectedAuthSignatory">
                        <div class="selected_list" v-if="selectedAuthSignatory"> 
                            <div class="selected_item" >
                                <span class="dp">
                                    <avatar :size="34" :backgroundColor="'#0E1D48'" :initials="avtarName(selectedAuthSignatory, 'name')"></avatar>
                                </span>
                                <div class="list_info">
                                    <div class="sign_title">
                                        <p>{{ checkProperty(selectedAuthSignatory, 'name') }}</p>
                                        <span v-if="checkProperty(selectedAuthSignatory, 'phone')&&checkProperty(selectedAuthSignatory, 'phoneCountryCode','countryCallingCode')">{{ checkProperty(selectedAuthSignatory, 'phoneCountryCode','countryCallingCode')+' '+checkProperty(selectedAuthSignatory, 'phone') }}</span>
                                    </div>
                                    <span class="email" v-if="checkProperty(selectedAuthSignatory, 'email')">
                                        <img src="@/assets/images/closed_mail.png" />
                                        {{ checkProperty(selectedAuthSignatory, 'email') }}
                                    </span>
                                </div>
                                <a @click="selectedAuthSignatory=null" class="close-icon">
                                    <XIcon size="16" />
                                </a>
                            </div>
                        </div>
                    </template>
                    <p class="createnew marb15">Not found?
                        <span @click="addNewSignatory()">Add Signatory</span>
                    </p>
                    <div class="text-danger text-sm formerrors custom_margin" v-show="requestErr">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                        icon="IP-information-button" active="true">{{ requestErr }}</vs-alert>
                    </div>                    
                </div>
                <div class="popup-footer relative">
                    <span class="loader" v-if="loadingRequest" ><img src="@/assets/images/main/loader.gif" /></span>
                    <vs-button color="dark" @click="hideAuthSignRequestModal()" class="cancel" type="filled">Cancel</vs-button>
                    <vs-button color="success" @click="requestSignatory()" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </div>
        </modal>
        <inviteSignatory v-if="requestNewSignatory" @closeNewSignatoryPopUp="closeNewSignatoryPopUp" :caseDetails="caseDetails" />
        <div v-if="successModal">
        <sucessPopup v-if="successModal" :successTitle='successTitle'/>  
        </div> 
        
    </div>
</template>
<script>
import { XIcon } from "vue-feather-icons";
import Avatar from 'vue-avatar'
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import sucessPopup from "./sucessModal";
import inviteSignatory from './inviteSignatory.vue';

    export default {
        components:{
            XIcon,
            sucessPopup,
            inviteSignatory,
            Avatar
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data: () => ({
            requestNewSignatory: false,
            successTitle:null,
            successModal:false,
            selectedAuthSignatory:null,
            comments:'',
            authSignatoryList:[],
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
            },
            loadingRequest:false,
            requestErr:'',
        }),
        props:{
            message:{
                type:Object,
                default:null
            },
        },
        methods:{
            addNewSignatory(){
                this.requestNewSignatory=true
            },
            closeNewSignatoryPopUp(data){
              this.getAuthSignatoryList()
              this.requestNewSignatory=false
              if(data && data._id){
              this.selectedAuthSignatory = data
              }else{
              this.selectedAuthSignatory = null
              }
          },

          getAuthSignatoryList(){
            let postData = {
                "matcher": {
                    "title": "" // search with name, email
                },
                "page": 1,
                "perpage": 10000
                // "petitionerId": "6672ad8157c5ed07e47d3e11" // send this when law firm admin login's and goes to i9 details to select auth signer
             }    
             
                if([3].indexOf(this.getUserRoleId)>-1 && this.getTenantTypeId == 1){
                    postData['petitionerId'] = this.checkProperty(this.caseDetails, 'petitionerId')
                }


                this.$store.dispatch("commonAction", { "data": postData, "path": '/users/get-auth-signers' }).then((response)=>{
                this.authSignatoryList = response.list;
                let defaultSigner = response.list.find(item => item.defaultSigner === true);
                if(defaultSigner){
                    this.selectedAuthSignatory =defaultSigner
                }    
                // let filteredData = [];
                // _.forEach(this.authSignatoryList, (item) => {
                //     if (item && (_.has(item, 'name') || _.has(item, 'email'))) {

                //     if ((_.has(item, 'name') && item['name'].includes(text)) || (_.has(item, 'email') && item['email'].includes(text))) {
                //         filteredData.push(item)
                //     } else {
                //         return false;
                //     }

                //     } else {
                //     return false;
                //     }
                // })
                // let authSignatoryList = _.cloneDeep(this.authSignatoryList);
                // this.authSignatoryList = [];
                // _.forEach(authSignatoryList, (item) => {
                //     if (this.checkProperty(item, 'name')) {
                //     if (this.checkProperty(item, 'email')) {
                //         item['name'] = item['name'] + " (" + item['email'] + ")"
                //     }
                //     this.authSignatoryList.push(item);
                //     }
                // })
                })
            },
            requestSignatory(){
                this.$validator.validateAll('requestAuthSign').then(result => {
                    if(result){
                        let postData = {
                            "i9Id": this.checkProperty(this.caseDetails, '_id'),
                            "authSignerInfo": {
                                "phoneCountryCode": {
                                    "countryCode": "IN",
                                    "countryCallingCode": ""
                                },
                                "homePhoneCountryCode": {
                                    "countryCode": "IN",
                                    "countryCallingCode": ""
                                },
                                "name": "",
                                "firstName": "",
                                "middleName": "",
                                "lastName": "",
                                "title": "",
                                "email": "",
                                "phone": "",
                                "homePhone": "",
                                "defaultSigner": true,
                                "_id": ""
                            }
                        }
                        postData['authSignerInfo'] = this.selectedAuthSignatory
                        this.successTitle=null
                        this.requestErr = '';
                        this.loadingRequest = true;
                        this.$store.dispatch("commonAction", { "data": postData, "path": '/i9/assign-auth-signer' }).then((response)=>{
                            this.showToster({message:response.message ,isError:false});
                            this.loadingRequest = false;
                            //this.hideRequestModal();
                           // this.successModal=true
                            setTimeout(()=>{
                                this.hideAuthSignRequestModal();
                            },1000)
                            this.successTitle='I-9 Request has been sent'
                            // setTimeout(()=>{
                            //     this.successModal=false
                            //      this.successTitle=null
                            //     // console.log('setTimeout',this.successTitle)
                            //      //console.log('this.successModal',this.successModal)
                            // },3000)
                           
                        }).catch((err)=>{
                            this.showToster({message:err ,isError:true});
                            this.requestErr = err;
                            this.loadingRequest = false;
                        })
                    }
                })
            },
            hideAuthSignRequestModal(data = null){
                this.selectedAuthSignatory = null;
                this.comments = '';
                this.requestErr= '';
                this.$emit('hideAuthSignRequestModal', data)
                this.$modal.hide('requestAuthSignModal');
            },
        },
        props:{
        caseDetails:null
        },
        mounted(){
            this.getAuthSignatoryList()
            this.$modal.show('requestAuthSignModal');
        }
    }


</script>